export default __webpack_public_path__ + "static/media/pixellab--graphic-design--01--1200x900.5693a1c2.jpg";